var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"light":"","top":"","id":"snackbarMessage","transition":"slide-y-transition","color":_vm.color},model:{value:(_vm.showSnackBar),callback:function ($$v) {_vm.showSnackBar=$$v},expression:"showSnackBar"}},[_c('div',{staticClass:"text-center"},[_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }